import { createSelector } from 'reselect'

const persons = state => state.api.locales.data

const mapForDropdown = (locales = []) => {
  return locales.filter(item => item.isTranslationLocale).map(item => ({
    value: item.id,
    label: item.name
  }))
}

export default createSelector(persons, mapForDropdown)
